import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, Typography } from "@mui/material";

const ElapsedDaysField = ({
  elapsedDays,
  setElapsedDays,
}: {
  elapsedDays: string;
  setElapsedDays: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t } = useTranslation("questEditor");

  const handleElapsedDaysChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setElapsedDays(e.target.value);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <TextField
        size="small"
        value={elapsedDays}
        onChange={handleElapsedDaysChange}
      ></TextField>
      <Typography color="primary">
        {t("quest_edit_target.field.purchase.elapsed_days.label")}
      </Typography>
    </Stack>
  );
};

export default ElapsedDaysField;
